export default __webpack_public_path__ + "static/media/logo-2.ac3db781.png";